export default __webpack_public_path__ + "static/media/hotel.a32ad691.svg";